"use strict";

exports.__esModule = true;
exports.isMatchOption = isMatchOption;
exports.matchList = matchList;
exports.urlMatch = urlMatch;
var _is = require("./is");
var _polyfills = require("./polyfills");
function isMatchOption(item) {
  return (0, _is.isString)(item) || (0, _is.isFunction)(item) || (0, _is.isRegExp)(item);
}

/**
 * 如果值有一个选项匹配，则返回true。在比较字符串时，useStartsWith: true时将把值与选项的开始进行比较，而不是要求精确匹配。
 */
function matchList(list, value, useStartsWith) {
  if (useStartsWith === void 0) {
    useStartsWith = true;
  }
  return list.some(function (item) {
    try {
      if (typeof item === 'function') {
        return item(value);
      } else if (item instanceof RegExp) {
        return item.test(value);
      } else if (typeof item === 'string') {
        return useStartsWith ? (0, _polyfills.startsWith)(value, item) : item === value;
      }
    } catch (e) {}
    return false;
  });
}
function urlMatch(url, list) {
  if (list === void 0) {
    list = [];
  }
  try {
    var rules = [/https?:\/\/.*rum|retcode\.aliyuncs\.com/, /https?:\/\/.*log-global\.aliyuncs\.com/, /https?:\/\/.*\.mmstat\.com/].concat(list);
    return matchList(rules, url);
  } catch (e) {
    return false;
  }
}